import { getElementParents } from '../helpers/general';

const isOnlineEventCheckBox = document.querySelector('#EditEventForm_EditEventForm_IsOnline');
const isOnlineSubscribeCheckBox = document.querySelector('#SubscribeEventForm_SubscribeEventForm_IsOnline');
const subscribeLinkTextArea = document.querySelector('#SubscribeEventForm_SubscribeEventForm_SubscribeLink');
const policyCommitteeCheckbox = document.querySelector('#VogForm_VogForm_VogVolunteerGroup_Beleidscommissie');
const electionCommitteeHolder = document.querySelector('#VogForm_VogForm_ElectionCommission_Holder');
const electionCommitteeOnlyCheckbox = document.querySelector('#VogForm_VogForm_ElectionCommission_Ja_alleen_de_kiescommissie');
const organisationCommitteeCheckbox = document.querySelector('#VogForm_VogForm_VogVolunteerGroup_Organisatie_commissie');
const districtChairmanHolder = document.querySelector('#VogForm_VogForm_DistrictChairman_Holder');

const vogFormCheckBoxAndRadio = document.querySelectorAll('#VogForm_VogForm input[type=checkbox], #VogForm_VogForm input[type=radio]');

if (isOnlineEventCheckBox) {
  checkOnlineFields(isOnlineEventCheckBox);
  isOnlineEventCheckBox.addEventListener('change', () => {
    checkOnlineFields(isOnlineEventCheckBox);
  });
}

if (isOnlineSubscribeCheckBox) {
  checkOnlineFields(isOnlineSubscribeCheckBox);
  isOnlineSubscribeCheckBox.addEventListener('change', () => {
    checkOnlineFields(isOnlineSubscribeCheckBox);
  });
}

if (subscribeLinkTextArea) {
  checkSubscribeLink(subscribeLinkTextArea);

  const listener = () => {
    checkSubscribeLink(subscribeLinkTextArea);
  };

  subscribeLinkTextArea.addEventListener('keyup', listener);
  subscribeLinkTextArea.addEventListener('change', listener);
}

if (vogFormCheckBoxAndRadio) {
  const listener = () => {
    const groupColors = [];
    const checkedInputs = document.querySelectorAll('#VogForm_VogForm_VogVolunteerGroup input:checked');
    const districtChairmanCheckbox = document.querySelector('input[name="DistrictChairman"]:checked');

    checkedInputs.forEach((input) => {
      groupColors.push(input.dataset.color);
    });

    if (districtChairmanCheckbox && districtChairmanCheckbox.value === 'Ja') {
      groupColors.push('group-color-green');
    }

    // Reset fields
    document.querySelectorAll('.commission-text').forEach((el) => {
      el.style.display = 'none';
    });

    document.querySelectorAll('.btn-toolbar button').forEach((el) => {
      el.innerText = 'Vraag aan';
    });

    getElementParents(vogFormCheckBoxAndRadio, 'form').forEach((el) => {
      el.classList.remove('toolbar-hidden');
    });

    const showCommisionsByColor = (color) => {
      document.querySelectorAll(`.field.${color}-commissions`).forEach((el) => {
        el.style.display = '';
      });

      document.querySelector('#VogForm_VogForm_Color').value = color;
    };

    // Set the color
    if (groupColors.indexOf('group-color-green') !== -1) {
      showCommisionsByColor('green');
    } else if (groupColors.indexOf('group-color-blue') !== -1) {
      showCommisionsByColor('blue');
    } else if (groupColors.indexOf('group-color-red') !== -1) {
      showCommisionsByColor('red');
    } else if (groupColors.indexOf('group-color-purple') !== -1) {
      showCommisionsByColor('purple');

      document.querySelectorAll('.btn-toolbar button').forEach((el) => {
        el.innerText = 'Bevestig';
      });

      getElementParents(vogFormCheckBoxAndRadio, 'form').forEach((el) => {
        el.classList.add('toolbar-hidden');
      });
    }

    // If "Beleidscommissie" is checked
    if (policyCommitteeCheckbox && policyCommitteeCheckbox.checked) {
      document.querySelectorAll('.commision-text').forEach((el) => {
        el.style.display = 'none';
      });

      electionCommitteeHolder.classList.remove('field-hidden');
    } else {
      electionCommitteeHolder.classList.add('field-hidden');
      electionCommitteeHolder.querySelectorAll('input').forEach((el) => {
        el.checked = false;
      });
    }

    const volunteerGroupCheckedCheckboxes = document.querySelectorAll('#VogForm_VogForm_VogVolunteerGroup_Holder input:checked');
    const electionCommisionIsChecked = electionCommitteeOnlyCheckbox && electionCommitteeOnlyCheckbox.checked;

    if ((electionCommisionIsChecked && volunteerGroupCheckedCheckboxes.length === 1) || (electionCommisionIsChecked && volunteerGroupCheckedCheckboxes.length === 2 && groupColors.indexOf('group-color-purple') !== -1)) {
      document.querySelectorAll('.commission-text').forEach((el) => {
        el.style.display = 'none';
      });

      if (groupColors.indexOf('group-color-purple') !== -1) {
        document.querySelectorAll('.field.choosing-and-jury-commission').forEach((el) => {
          el.style.display = '';
        });
      } else {
        document.querySelectorAll('.field.choosing-commission').forEach((el) => {
          el.style.display = '';
        });
      }

      getElementParents(vogFormCheckBoxAndRadio, 'form').forEach((el) => {
        el.classList.add('toolbar-hidden');
      });
    } else {
      electionCommitteeHolder.classList.add('desc-hidden');

      if (volunteerGroupCheckedCheckboxes.length !== 1 && groupColors.indexOf('group-color-purple') === -1) {
        getElementParents(vogFormCheckBoxAndRadio, 'form').forEach((el) => {
          el.classList.remove('toolbar-hidden');
        });
      }
    }

    if (organisationCommitteeCheckbox && organisationCommitteeCheckbox.checked) {
      districtChairmanHolder.classList.remove('field-hidden');
    } else {
      districtChairmanHolder.classList.add('field-hidden');

      districtChairmanHolder.querySelectorAll('input').forEach((el) => {
        el.checked = false;
      });
    }
  };

  vogFormCheckBoxAndRadio.forEach((input) => {
    input.addEventListener('change', listener);
  });
}

function checkOnlineFields(checkbox) {
  document.querySelectorAll('.online-hidden-fields').forEach((el) => {
    el.querySelectorAll('input[type=text]:not([name="AddressExtra"])').forEach((input) => {
      if (checkbox.checked) {
        input.removeAttribute('required');
      } else {
        input.setAttribute('required', 'required');
      }

      input.value = '';
    });

    el.style.display = checkbox.checked ? 'none' : '';
  });
}

function checkSubscribeLink(textarea) {
  if (textarea.value.length === 0) {
    document.querySelectorAll('.subscribe-link-hidden').forEach((el) => {
      el.querySelectorAll('input').forEach((input) => {
        input.removeAttribute('required');
        input.value = '';
      });

      el.style.display = 'none';
    });
  } else {
    document.querySelectorAll('.subscribe-link-hidden').forEach((el) => {
      el.querySelectorAll('input[name="SubscribeBeforeDate"]').forEach((input) => {
        input.removeAttribute('required');
        input.value = '';
      });

      el.querySelectorAll('input[type=date]:not([name="SubscribeBeforeDate"])').forEach((input) => {
        input.setAttribute('required', 'required');
      });

      el.style.display = '';
    });
  }
}
